import type {
  EmitsOptions,
  ExtractPropTypes,
  ExtractPublicPropTypes,
  PropType,
} from "vue";
import type { WithOnEmits } from "../../../utils";
import type Select from "./select.vue";

export const SelectProps = {
  multiple: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  valueKey: {
    type: String,
    default: "value",
  },
  size: String as PropType<"" | "large" | "default" | "small">,
  collapseTags: Boolean,
  collapseTagsTooltip: Boolean,
  multipleLimit: Number,
  name: String,
  effect: String as PropType<"dark" | "light">,
  autocomplete: String,
  placeholder: {
    type: String,
    default: "请选择",
  },
  filterable: Boolean,
  allowCreate: Boolean,
  filterMethod: Object as PropType<() => void>,
  remote: Boolean,
  remoteMethod: Object as PropType<() => void>,
  remoteShowSuffix: Boolean,
  loading: {
    type: Boolean,
    default: false,
  },
  noMatchText: String,
  noDataText: String,
  popperClass: String,
  reserveKeyword: Boolean,
  defaultFirstOption: Boolean,
  teleported: Boolean,
  persistent: {
    type: Boolean,
    default: true,
  },
  clearIcon: [String, Object],
  fitInputWidth: Boolean,
  placement: {
    type: String as PropType<
      | "top"
      | "top-start"
      | "top-end"
      | "bottom"
      | "bottom-start"
      | "bottom-end"
      | "left"
      | "left-start"
      | "left-end"
      | "right"
      | "right-start"
      | "right-end"
    >,
    default: "bottom-start",
  },
  modelValue: [String, Number, Array, null],
  clearable: {
    type: Boolean,
    default: true,
  },
  loadingText: {
    type: String,
    default: "数据加载中",
  },
  data: {
    type: [Array, String],
    default: () => [],
  },
  dataCallback: {
    type: Function,
  },
  optLabel: {
    type: String,
    default: "label",
  },
  optValue: {
    type: String,
    default: "value",
  },
  /**
   * pinia useDictStore
   */
  action: Object,
};

export const SelectEmits = {
  visibleChange: (visible: boolean) => visible,
  removeTag: (tagValue: any) => tagValue,
  "update:modelValue": (value: any) => value,
  clear: () => true,
  blur: (evt: MouseEvent) => evt,
  focus: (evt: MouseEvent) => evt,
  change: (value: any) => value,
} satisfies EmitsOptions;

export type SelectPropsType = ExtractPropTypes<typeof SelectProps>;
export type SelectPublicPropsType = ExtractPublicPropTypes<typeof SelectProps> &
  WithOnEmits<typeof SelectEmits>;
export type SelectEmitsType = typeof SelectEmits;
export type SelectInstance = InstanceType<typeof Select>;
